import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium, {Style} from 'radium';

import * as defaultStyles from '../../../styles';
import {request} from '../../../containers/actions';
import { host_v2 } from '../../../utilities/requests';

//Radium(ClassReport);
export default class ClassReport extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        if (this.props.school && this.props.examination && this.props.examination.id)
            this.fetchReport.bind(this)();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.school !== this.props.school ||
            (prevProps.examination && prevProps.examination.id) !==
            (this.props.examination && this.props.examination.id)) {
            this.fetchReport.bind(this)();
        }
        if (!prevState.print && this.state.print) {
            window.scrollTo(0, 0);
            window.print();
            this.setState({print: false});
        }
    }

    async fetchReport() {
        const school = this.props.school;
        if (!school || !this.props.examination || !this.props.examination.id) {
            this.setState({data: undefined});
            return;
        }
        this.setState({data: null});
        const response = await this.context.store.dispatch(request({
            path: `/examination/${this.props.examination.id}/report/school/class/`,
            body: {school},
        }));
        this.setState({data: response});
    }
    excel(){    
        var token = this.context.store.getState().get('application').get('token'); 
        var auth =token.get('accessToken');
        var url = host_v2 + "/ExportExcel/ClassReport?authToken="+auth+"&examId="+this.props.examination.id
        +"&school="+this.props.school;
        console.log(url,'urlsss')
        window.open(url, '_blank'); 
    }
    getValuType2(id,material,field) {
        try {
            return this.state.data.classes[id][material && material.id][field];
        }
        catch (er) {
            return '-';
        }
    }

    render() {
        if (!this.state || !this.state.data)
            return null;
        if (_.size(this.state.data.classes) === 0)
            return <div>{window.gettext('Please check again later!')}</div>;
        return <span>
            <div style={{marginBottom: '.5em'}}>
                <button
                    key='print'
                    style={{...defaultStyles.defaultButton, backgroundColor: defaultStyles.fourthColor, float: 'left' , marginBottom:"10px"}}
                    onClick={() => this.setState({print: true})}>
                    {window.gettext('Print')}
                </button>&nbsp;
            </div>
            {this.state.data
                ? <span>
                    <div
                        style={{
                            ...defaultStyles.box,
                            width: '100%',
                            overflow: 'hidden',
                        }}>
                        <div style={{float: 'right', width: '25%'}}>
                            {window.gettext('Examination')}: {this.props.examination.title}
                        </div>
                        <div style={{float: 'right', width: '25%'}}>
                            {window.gettext('School Name')}: {this.state.data.school_display}
                        </div>
                        <div style={{float: 'right', width: '25%'}}>
                            {window.gettext('City')}: {this.state.data.city_display}
                        </div>
                        <div style={{float: 'right', width: '25%'}}>
                            {window.gettext('Grade')}: {this.state.data.grade_display}
                        </div>
                        <div style={{float: 'right', width: '25%'}}>
                            {window.gettext('Holding Date')}: {this.props.examination.date ? this.props.examination.date.toJalali().persian() : ''}
                        </div>
                        <div style={{float: 'right', width: '25%'}}>
                            {window.gettext('Analyze Date')}: {this.props.examination.analyze_date
                                ? this.props.examination.analyze_date.toJalali().persian()
                                : ''
                            }
                        </div>
                        <div style={{float: 'right', width: '25%'}}>
                            {window.gettext('Centers Participated')}: {(this.state.data.centers || '').persian()}
                        </div>
                        <div style={{float: 'right', width: '25%'}}>
                            {window.gettext('Classes Participated')}: {(this.state.data.classes_participated || '').persian()}
                        </div>
                        <div style={{clear: 'right', textAlign: 'center', fontWeight: '700'}}>
                            {window.interpolate(
                                window.gettext('Ranks are based on %(analyzeModel)s!'),
                                {analyzeModel: this.props.examination.analyze_model === 1 ? window.gettext('Taraz') : window.gettext('Score')},
                                true,
                            )}
                        </div>
                    </div>
                    <span class='media-print-display'>
                        <div
                            style={{
                                position: 'fixed',
                                top: '21mm',
                                right: '61mm',
                                width: '52mm',
                                fontSize: '1.65em',
                            }}>
                            <div style={{textAlign: 'center'}}>
                                <b>{window.gettext('Class Report')}</b>
                            </div>
                        </div>
                        <div
                            style={{
                                position: 'fixed',
                                top: '9mm',
                                right: '127mm',
                                width: '63.2mm',
                            }}>
                            <div style={{overflow: 'hidden', height: '2.3em'}}>
                                <b>{window.gettext('School Name')}:</b>&nbsp;
                                {this.state.data.school_display} - {this.state.data.city_display}
                            </div>
                            <div style={{overflow: 'hidden', height: '2.3em'}}>
                                <b>{window.gettext('Examination')} - {window.gettext('Grade')}:</b>&nbsp;
                                {this.props.examination.title} - {this.state.data.grade_display}
                            </div>
                        </div>
                        <div
                            style={{
                                position: 'fixed',
                                top: '9mm',
                                right: '202mm',
                                width: '42mm',
                            }}>
                            <div style={{overflow: 'hidden', height: '2.3em'}}>
                                <b>{window.gettext('Holding Date')}:</b> {this.props.examination.date
                                    ? this.props.examination.date.toJalali().persian()
                                    : ''
                                }
                            </div>
                            <div style={{overflow: 'hidden', height: '2.3em'}}>
                                <b>{window.gettext('Classes Participated')}:</b> {(this.state.data.classes_participated || '').persian()}
                            </div>
                        </div>
                        <div
                            style={{
                                position: 'fixed',
                                top: '9mm',
                                right: '254mm',
                                width: '34mm',
                            }}>
                            <div style={{overflow: 'hidden', height: '2.3em'}}>
                                <b>{window.gettext('Centers Participated')}:</b> {(this.state.data.centers || '').persian()}
                            </div>
                            <div style={{overflow: 'hidden', height: '2.3em'}}>
                                <b>{window.gettext('Rank Among Schools')}:</b> {(this.state.data.school_rank || '').persian()}
                            </div>
                        </div>
                        <div
                            style={{
                                position: 'fixed',
                                top: '195mm',
                                right: '16mm',
                                width: '71mm',
                            }}>
                            <div style={{overflow: 'hidden', height: '2.3em'}}>
                                <b>{window.gettext('Analyze Date')}:</b> {this.props.examination.analyze_date
                                    ? this.props.examination.analyze_date.toJalali().persian()
                                    : ''
                                }
                            </div>
                        </div>
                        <div
                            style={{
                                position: 'fixed',
                                top: '195mm',
                                right: '120mm',
                                fontSize: '1.3em',
                                fontFamily: 'Arial',
                            }}>
                            <b>www.mhelli.ir</b>
                        </div>
                        <Style
                            rules={{
                                '@page': {
                                    size: 'A4 Landscape',
                                    margin: '0',
                                },
                                mediaQueries: {
                                    print: {
                                        '*': {
                                            backgroundColor: 'unset !important',
                                        },
                                        body: {
                                            visibility: 'hidden',
                                        },
                                        '.page': {
                                            minHeight: 'unset',
                                        },
                                    },
                                },
                            }}>
                        </Style>
                    </span>
                </span>
                : null
            }
            <div
                style={{'@media screen': {
                    ...defaultStyles.box,
                    marginTop: '1em',
                }}}>
                <div style={{display:this.state.print ? undefined : 'inline-block' , width:"100%"}} class='media-print-display school-school-media-print'>

                <button
                    style={{
                        ...defaultStyles.defaultButton,
                        padding: '.5em',
                        boxSizing: 'border-box',
                        margin: '10px 0',

                        display: this.state.print ? 'none' : undefined,
                    }}

                    onClick={() => this.excel()}
                >خروجی اکسل</button>
                    <table style={{...defaultStyles.table , width:"100%"}}>
                        <thead style={{backgroundColor: '#cccccc'}}>
                            <tr style={{'@media print': {height: '34mm', border: 'none'}}}/>
                            <tr>
                                <th rowSpan='2' style={{...defaultStyles.th,padding:"0.5em", width: '9em' , fontSize:"13px"}}>
                                    {window.gettext('کلاس')}
                                </th>
                                {_.map([...this.props.examination.materials ,{id:0 , title:"کل"}], ({title},index) => <th
                                    key={index}
                                    colSpan='3'
                                    style={{...defaultStyles.th, width: '3em' ,fontSize:"13px" ,padding:"0.5em" }}>
                                    {title.persian()}
                                </th>)}
                            </tr>
                            <tr>
                                {_.map([...this.props.examination.materials ,0], id => [
                                    <th key={id + 'taraz'} style={{...defaultStyles.th, width: '3em' , fontSize:"12px",padding:"0.5em"}}>
                                        {window.gettext('Taraz')}
                                    </th>,
                                    id != 0 && <th key={id + 'average'} style={{...defaultStyles.th, width: '3em',fontSize:"12px",padding:"0.5em"}}>
                                        {window.gettext('Average')}
                                    </th>,
                                    <th key={id + 'rank'} style={{...defaultStyles.th, width: '3em',fontSize:"12px",padding:"0.5em"}}>
                                        {window.gettext('Rank')}
                                    </th>,
                                ])}
                            </tr>
                        </thead> 
                        {console.log(this.state.data.classes)}     
                        {_.map(Object.keys(this.state.data.classes) , (clazz ,id)=>{
                           return <tr>  
                                <td
                                    style={{...defaultStyles.td, width: '3em', textAlign: 'center', fontSize:"14px" , fontWeight:"bold" , backgroundColor: '#cccccc',padding:"0.5em"}}>
                                    {this.state.data.classes[clazz].name.persian()}
                                </td>
                                {_.map([...this.props.examination.materials , {id:0 , title:"کل"}] , ({id} , index)=>
                                    <>
                                    <td
                                        style={{...defaultStyles.td, width: '3em', textAlign: 'center', fontSize:"12px",padding:"0.5em"}}>
                                        {this.state.data?.classes?.[clazz]?.[id]?.taraz?.toFixed()?.persian()}
                                    </td>
                                    { id != 0 &&
                                        <td
                                            style={{...defaultStyles.td, width: '3em', textAlign: 'center' , fontSize:"12px",padding:"0.5em"}}>
                                            {this.state.data?.classes?.[clazz]?.[id]?.average?.toPercent()?.persian()}
                                        </td>
                                    }
                                    <td
                                        style={{...defaultStyles.td, width: '3em', textAlign: 'center', fontSize:"12px",padding:"1em 0.3em"}}>
                                        {this.state.data?.classes?.[clazz]?.[id]?.rank?.persian()}
                                    </td>
                                    </>
                                    
                                )}
                            </tr>
                        })}
                        <tfoot>
                            <tr style={{height: '26mm'}}></tr>  
                        </tfoot>
                    </table>
                </div>
            </div>
        </span>;
    }
}
